import { PlanExtra, PlanExtraDetail } from '@dtx-company/true-common/src/types/Plan'

export function toPlanExtraDetails(
  jsonPlanExtraDetails: PlanExtraDetail[],
  planExtras: PlanExtra[]
): PlanExtraDetail[] {
  return (jsonPlanExtraDetails || []).map(jsonPlanExtraDetail => {
    return {
      planExtraId: jsonPlanExtraDetail.planExtraId,
      quantity: jsonPlanExtraDetail.quantity,
      planExtra: planExtras.find(
        planExtra => planExtra.planExtraId === jsonPlanExtraDetail.planExtraId
      )
    }
  })
}
